import { create } from 'zustand';
import { Document, LegalMatter } from '../types';
import { sampleDocuments, sampleMatters } from '../data';

interface PortalState {
  documents: Document[];
  matters: LegalMatter[];
  isPortalOpen: boolean;
  activeTab: 'documents' | 'matters';
  selectedMatter: string | null;
  uploadProgress: number | null;
  setPortalOpen: (open: boolean) => void;
  setActiveTab: (tab: 'documents' | 'matters') => void;
  setSelectedMatter: (id: string | null) => void;
  addDocument: (doc: Document) => void;
  setUploadProgress: (progress: number | null) => void;
}

export const usePortalStore = create<PortalState>((set) => ({
  documents: sampleDocuments,
  matters: sampleMatters as LegalMatter[],
  isPortalOpen: false,
  activeTab: 'documents',
  selectedMatter: null,
  uploadProgress: null,
  setPortalOpen: (open) => set({ isPortalOpen: open }),
  setActiveTab: (tab) => set({ activeTab: tab }),
  setSelectedMatter: (id) => set({ selectedMatter: id }),
  addDocument: (doc) => set((state) => ({ documents: [doc, ...state.documents] })),
  setUploadProgress: (progress) => set({ uploadProgress: progress }),
}));

interface BookingState {
  step: number;
  selectedArea: string;
  selectedDate: string;
  selectedTime: string;
  formData: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    description: string;
  };
  setStep: (step: number) => void;
  setSelectedArea: (area: string) => void;
  setSelectedDate: (date: string) => void;
  setSelectedTime: (time: string) => void;
  setFormData: (data: Partial<BookingState['formData']>) => void;
  resetBooking: () => void;
}

export const useBookingStore = create<BookingState>((set) => ({
  step: 1,
  selectedArea: '',
  selectedDate: '',
  selectedTime: '',
  formData: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    description: '',
  },
  setStep: (step) => set({ step }),
  setSelectedArea: (area) => set({ selectedArea: area }),
  setSelectedDate: (date) => set({ selectedDate: date }),
  setSelectedTime: (time) => set({ selectedTime: time }),
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetBooking: () => set({ step: 1, selectedArea: '', selectedDate: '', selectedTime: '', formData: { firstName: '', lastName: '', email: '', phone: '', description: '' } }),
}));
